<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">Thanks to my wonderful wife, supporter and reader, Michele; my writer son, Sean Kanan, who provided me with the idea for this book; and my daughter, Robyn Bernstein, for being my daughter and a great writer as well.</p>
<p class="indent">This is my fourth book with The History Press, and my acquisitions editor, Banks Smither, has again provided his invaluable support. I also appreciate the hard work and support of my editor Ashley Hill.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?22c5c0f0